import styleInject from '../../../dependencies/style-inject/dist/style-inject.es.js';

var css_248z = ".rf-menu[data-v-6e52f9c7] {\n  position: relative;\n  display: inline-flex;\n  width: 100%;\n}\n\n.rf-menu__toggle[data-v-6e52f9c7] {\n  width: 100%;\n}";
styleInject(css_248z);

export { css_248z as default };
